const StatusToast = ({ title, message, tone = 'success' }) => {
  const isError = tone === 'error';

  return (
    <div className="pointer-events-none fixed bottom-6 right-6 z-[80] flex justify-end px-0">
      <div
        className={`pointer-events-auto w-full max-w-sm rounded-[1rem] border bg-white px-4 py-3 shadow-[0_18px_40px_-24px_rgba(15,23,42,0.35)] ring-1 ${
          isError
            ? 'border-red-200 ring-red-100/80'
            : 'border-emerald-200 ring-emerald-100/80'
        }`}
      >
        <div className="flex items-start gap-3">
          <div
            className={`mt-0.5 flex h-8 w-8 items-center justify-center rounded-full ${
              isError ? 'bg-red-100 text-red-700' : 'bg-emerald-100 text-emerald-700'
            }`}
          >
            {isError ? (
              <svg className="h-4 w-4" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                <path fillRule="evenodd" d="M4.293 4.293a1 1 0 0 1 1.414 0L10 8.586l4.293-4.293a1 1 0 1 1 1.414 1.414L11.414 10l4.293 4.293a1 1 0 0 1-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 0 1-1.414-1.414L8.586 10 4.293 5.707a1 1 0 0 1 0-1.414Z" clipRule="evenodd" />
              </svg>
            ) : (
              <svg className="h-4 w-4" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                <path fillRule="evenodd" d="M16.704 5.29a1 1 0 0 1 .006 1.414l-7.2 7.26a1 1 0 0 1-1.42.008L3.3 9.18a1 1 0 1 1 1.4-1.428l4.08 4.002 6.5-6.456a1 1 0 0 1 1.424-.008Z" clipRule="evenodd" />
              </svg>
            )}
          </div>
          <div>
            <h3 className="text-sm font-semibold text-slate-900">{title}</h3>
            <p className="mt-1 text-xs text-slate-500">{message}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StatusToast;
